// src/hooks/useSubmitLock.js
import { useCallback, useRef, useState } from 'react';

export function useSubmitLock() {
    const lockRef = useRef(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const runWithLock = useCallback(async (fn) => {
        if (lockRef.current) return { blocked: true };

        lockRef.current = true;
        setIsSubmitting(true);

        try {
            return await fn();
        } finally {
            lockRef.current = false;
            setIsSubmitting(false);
        }
    }, []);

    return {
        isSubmitting,
        runWithLock,
    };
}
